import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App.tsx";
import {
  AuthProvider,
  logoutUser,
} from "./common/authentication/AuthLogin.tsx";
import { persistor, store } from "./redux/store/store.ts";
import { setupFcmMessageHandler } from "./firebase.ts";
import { StripeProvider } from "./common/components/stripe";
import { JitsiProvider } from "./common/contexts/VideoCallContext.tsx";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any) => {
      if (
        error?.message === "Unauthorized" &&
        location.pathname !== "/auth/login"
      ) {
        logoutUser();
      }
      if (error.status === 403) {
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (err: any) => {
      if (
        err?.message === "Unauthorized" &&
        location.pathname !== "/auth/login"
      ) {
        logoutUser();
      }
      if (err.status === 403) {
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

// FCM setup is non-critical for first paint — defer until the browser is idle.
const scheduleIdle =
  (window as unknown as { requestIdleCallback?: (cb: () => void) => void })
    .requestIdleCallback ?? ((cb: () => void) => setTimeout(cb, 1));
scheduleIdle(() => setupFcmMessageHandler());

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <AuthProvider>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <JitsiProvider>
            <StripeProvider>
              <App />
            </StripeProvider>
          </JitsiProvider>
        </QueryClientProvider>
      </PersistGate>
    </AuthProvider>
  </Provider>,
);
